"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["field", "name", "suffixIcon", "successIcon", "errorIcon", "hintText", "validate", "noSuccess", "trim", "hiddenError", "initiallyTouched", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { Box, EPositionerAlignment, Tooltip } from '@autoguru/overdrive';
import { useFormikContext } from 'formik';
import { useCallback, useState } from 'react';
import { useOdFormicField } from './useOdFormikField';
import { jsx as _jsx } from "react/jsx-runtime";
const INPUTS_WITH_CUSTOM_EVENTS = ['DateInput'];
export const FormikOdField = _ref => {
  var _ref2, _Field$displayName, _ref3;
  let {
      field: Field,
      name,
      suffixIcon,
      successIcon,
      errorIcon,
      hintText,
      validate,
      noSuccess = false,
      trim = false,
      hiddenError = false,
      initiallyTouched = false,
      className = ''
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const {
    setFieldValue
  } = useFormikContext();
  const {
    field,
    isValid,
    fieldIcon,
    touched: incomingTouched,
    error
  } = useOdFormicField({
    name,
    suffixIcon,
    errorIcon,
    successIcon,
    InputField: Field,
    validate
  });
  const [isFocused, setIsFocused] = useState(false);
  const formikHelpers = field;
  const fieldName = (_ref2 = (_Field$displayName = Field === null || Field === void 0 ? void 0 : Field.displayName) !== null && _Field$displayName !== void 0 ? _Field$displayName : Field === null || Field === void 0 ? void 0 : Field.name) !== null && _ref2 !== void 0 ? _ref2 : '';
  const isCustomField = INPUTS_WITH_CUSTOM_EVENTS.includes(fieldName);
  const touched = initiallyTouched === true || initiallyTouched === 'IF_VALID' && isValid || initiallyTouched === 'IF_INVALID' && !isValid || (noSuccess && isValid ? false : incomingTouched);
  const value = field.value || (typeof field.value === 'number' ? 0 : '');
  // Show raw value while focused, trim only when not focused and trim is enabled
  const displayValue = trim && !isFocused && typeof value === 'string' ? value.trim() : value;

  // onChange event handler for custom field implementations (e.g with react-aria)
  const handleChangeEvent = useCallback(valueOrEvent => {
    var _valueOrEvent$target;
    // DateInput from react-aria passes the value directly, not an event
    const value = typeof valueOrEvent === 'string' ? valueOrEvent : valueOrEvent === null || valueOrEvent === void 0 || (_valueOrEvent$target = valueOrEvent.target) === null || _valueOrEvent$target === void 0 ? void 0 : _valueOrEvent$target.value;
    setFieldValue(name, value);
  }, [name, setFieldValue]);

  // Compose onBlur handler to trim value when trim is enabled
  const handleBlur = useCallback(e => {
    setIsFocused(false);
    if (trim && typeof value === 'string') {
      const trimmed = value.trim();
      if (trimmed !== value && formikHelpers.onChange) {
        formikHelpers.onChange(_objectSpread(_objectSpread({}, e), {}, {
          target: _objectSpread(_objectSpread({}, e.target), {}, {
            name,
            value: trimmed
          })
        }));
      }
    }
    if (typeof rest.onBlur === 'function') {
      rest.onBlur(e);
    } else if (formikHelpers.onBlur) {
      formikHelpers.onBlur(e);
    }
  }, [trim, value, formikHelpers, name, rest.onBlur]);
  const handleFocus = useCallback(e => {
    setIsFocused(true);
    if (typeof rest.onFocus === 'function') {
      rest.onFocus(e);
    }
  }, [rest.onFocus]);
  const fieldProps = _objectSpread(_objectSpread({
    name
  }, field), {}, {
    className,
    value: displayValue,
    isValid,
    isTouched: touched,
    hintText: (_ref3 = hiddenError ? null : error) !== null && _ref3 !== void 0 ? _ref3 : hintText,
    suffixIcon: fieldIcon,
    onChange: isCustomField ? handleChangeEvent : field.onChange,
    onBlur: handleBlur,
    onFocus: handleFocus
  }, rest);
  return hiddenError ? /*#__PURE__*/_jsx(Tooltip, {
    label: error,
    alignment: EPositionerAlignment.TOP,
    children: /*#__PURE__*/_jsx(Box, {
      children: /*#__PURE__*/_jsx(Field, _objectSpread({}, fieldProps))
    })
  }) : /*#__PURE__*/_jsx(Field, _objectSpread({}, fieldProps));
};